var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
// import { AEvent } from "../../events/AppEvent";
import { Letr } from '@@/Letr';
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
// import { LStore } from "../LetrStore";
export class AdminTagLetrInfiniteStore {
    constructor() {
        this.maxList = 20;
        this.letrsMap = new Map();
        this.loadingHistory = false;
        this.loadingLatest = false;
        this.activeTagId = "";
        this.activeUserId = "";
        this.hasMore = false;
        makeObservable(this);
        APPEvent.addSubscriberForAdminTagChanged((tag) => this.tagChanged(tag.id));
        APPEvent.addSubscriberForLetrUserChanged((userid) => this.userchanged(userid));
        APPEvent.addSubscriberForAdminUserLetrsFortag((letrs) => {
            if (letrs.length < this.maxList) {
                this.setHasMore(false);
            }
            this.addLetrs(letrs);
            this.setLoadingLatest(false);
            this.setLoadingHistory(false);
        });
    }
    getLetrById(id) {
        return this.letrsMap.get(id);
    }
    setHasMore(hm) {
        this.hasMore = hm;
    }
    async loadLatest() {
        let after = 0;
        const sletrs = this.getSortedLetrs().reverse();
        if (sletrs && sletrs.length > 0) {
            after = sletrs[0].letrMetadata.updatetime;
        }
        if (after > 0) {
            const req = {
                userid: this.activeUserId,
                filter: { tagid: this.activeTagId, size: this.maxList, afterDate: after, beforeDate: -1, selectedGroup: [] }
            };
            this.setLoadingLatest(true);
            Apphandler.sendMessage("adminloaduserletrsfortag", req);
            // await LStore.loadUserLetrsForTag(this.activeUserId, {tagid:this.activeTagId, size: this.maxList, afterDate: after, beforeDate: -1, selectedGroup: []})
        }
    }
    async loadHistory() {
        if (this.loadingHistory || !this.hasMore) {
            return;
        }
        this.setLoadingHistory(true);
        let before = new Date().getTime();
        const sletrs = this.getSortedLetrs().reverse();
        if (sletrs && sletrs.length > 0) {
            before = sletrs[sletrs.length - 1].letrMetadata.updatetime;
        }
        if (before > 0) {
            const req = {
                userid: this.activeUserId,
                filter: { tagid: this.activeTagId, size: this.maxList, afterDate: -1, beforeDate: before, selectedGroup: [] }
            };
            Apphandler.sendMessage("adminloaduserletrsfortag", req);
            // await LStore.loadUserLetrsForTag(this.activeUserId, {tagid:this.activeTagId, size: this.maxList, afterDate: -1, beforeDate: before, selectedGroup: []})
        }
    }
    tagChanged(tagid) {
        this.reset();
        this.activeTagId = tagid;
        if (this.activeTagId) {
            this.loadHistory();
        }
    }
    userchanged(userid) {
        this.reset();
        this.activeUserId = userid;
    }
    getSortedLetrs() {
        return Array.from(this.letrsMap.values()).sort(this.sortLetr);
    }
    reset() {
        this.letrsMap = new Map();
        this.setHasMore(true);
        this.setLoadingHistory(false);
        this.setLoadingLatest(false);
        this.activeTagId = "";
    }
    removeLetr(letrid) {
        this.letrsMap.delete(letrid);
    }
    addLetrs(letrs) {
        letrs.forEach(lt => this.addLetr(lt));
    }
    addLetr(letr) {
        this.letrsMap.set(letr.id, letr);
    }
    sortLetr(l1, l2) {
        return l1.letrMetadata.updatetime - l2.letrMetadata.updatetime;
    }
    setLoadingHistory(load) {
        this.loadingHistory = load;
    }
    setLoadingLatest(load) {
        this.loadingLatest = load;
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminTagLetrInfiniteStore.prototype, "letrsMap", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminTagLetrInfiniteStore.prototype, "loadingHistory", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminTagLetrInfiniteStore.prototype, "loadingLatest", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminTagLetrInfiniteStore.prototype, "hasMore", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminTagLetrInfiniteStore.prototype, "setHasMore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminTagLetrInfiniteStore.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminTagLetrInfiniteStore.prototype, "removeLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Letr]),
    __metadata("design:returntype", void 0)
], AdminTagLetrInfiniteStore.prototype, "addLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminTagLetrInfiniteStore.prototype, "setLoadingHistory", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminTagLetrInfiniteStore.prototype, "setLoadingLatest", null);
